/**
 * @param {import('src/types/shares-store').SharesStoreState} state
 */
export function recoveryShares(state) {
  return state.shares.filter(({ source }) => source === 'recovery-mode');
}
